export default __webpack_public_path__ + "static/callipers-c193822b6ac3dda34637abd445deec69.png";